// ---------------------------------------------------------------------------
// AppGate — thin wrapper that renders the correct screen based on lock state
// ---------------------------------------------------------------------------

import { useAppLock, WelcomeScreen, SetupScreen, LockScreen } from './components/AppLock';
import { App } from './App';

export function AppGate() {
  const { isUnlocked, isConfigured, lock, isEnabled, decision, skipEncryption, enableEncryption } =
    useAppLock();

  if (decision === 'pending') {
    return <WelcomeScreen onEnable={enableEncryption} onSkip={skipEncryption} />;
  }

  if (isEnabled && !isConfigured) {
    return (
      <SetupScreen
        onSubmit={async (password) => {
          if (!lock) return;
          await lock.setup(password);
        }}
        onSkip={skipEncryption}
      />
    );
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return (
      <LockScreen
        onUnlock={async (password) => {
          if (!lock) return false;
          return lock.unlock(password);
        }}
      />
    );
  }

  if (!isUnlocked) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg)]">
        <div className="h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" />
      </div>
    );
  }

  return <App />;
}
